import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import IndividualPaymentCycleRegistrationForm from "../ones/IndividualPaymentCycleRegistrationForm";

export default function View({ debtUuid, studentUuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [debtData, setDebtData] = useState(null);
	const [studentData, setStudentData] = useState(null);
	const [studentPaymentsProfile, setStudentPaymentsProfile] = useState(null);
	const [paymentProfileInScope, setPaymentProfileInScope] = useState(null);
	const [loading, setLoading] = useState(false);

	const [amount, setAmount] = useState(0);
	const [payWith, setPayWith] = useState("bank");
	const [paymentDate, setPaymentDate] = useState("");
	const [receiptId, setReceiptId] = useState("");
	
	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getDebtData(),
			getStudentData(),
			getStudentPaymentsProfile(),
		]);
		setReady(true);
	}

	function getPaymentProfileInScope() {
		if(studentPaymentsProfile) {
			for (const _profile of studentPaymentsProfile.allDebts) {
				if(_profile.uuid === debtUuid) {
					setPaymentProfileInScope(_profile);
				}
			}
		}
	}

	async function getDebtData() {
		await callApi("get-debt-data", { uuid: debtUuid }).then(response => {
			if (response.status === 1) {
				setDebtData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	async function getStudentData() {
		await callApi("get-student-data", { uuid: studentUuid }).then(response => {
			if (response.status === 1) {
				setStudentData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	async function getStudentPaymentsProfile() {
		await callApi("get-student-payments-profile", { uuid: studentUuid }).then(response => {
			if (response.status === 1) {
				setStudentPaymentsProfile(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	function resetForm() {
		setAmount(0);
		setReceiptId("");
		setPaymentDate("");
	}

	async function submitPayment() {
		const receiptFile = document.getElementById("_receiptFile").files[0];

		if(!isNaN(amount) && Number(amount) > 0) {
			if(payWith && payWith.trim().length > 0) {
				if(
					(receiptId && receiptId.trim().length > 0) ||
					receiptFile
				) {
					if(paymentDate && paymentDate.trim().length > 0) {
						setLoading(true);
						await callApi(
							'create-payment-record',
							{
								amount,
								payWith,
								receiptId,
								receiptFile: (receiptFile || ''),
								paymentDate,
								debtUuid,
								schoolUuid: appContext.currentSchoolUuid,
								studentUuid,
							}
						).then(response => {
							if(response.status === 1) {
								appContext.tellMessage("Payment was received");
								resetForm();
								init();
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError("Invalid payment date");
					}
				} else {
					appContext.tellError("Provide either receipt file or ID");
				}
			} else {
				appContext.tellError("Invalid payment method");
			}
		} else {
			appContext.tellError("Invalid amount paid");
		}
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getPaymentProfileInScope();
	}, [ studentPaymentsProfile ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if (ready && debtData && studentData && studentPaymentsProfile && paymentProfileInScope) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Collections for Student Debt
							<br/>
							<span className="badge bg-dark">Payment Collection</span>
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Debt Title</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{debtData.title}
						</h6>
					</div>

					<div className="col-md-6 mt-2 mb-2">
						<label className="form-label">Debt Due Date</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{debtData.dateDue}
						</h6>
					</div>

					

					<div className="col-md-12 mt-2 mb-2">
						<label className="form-label">Debt Description</label>
						<pre
							style={{
								fontSize: "18px",
							}}
						>
							{debtData.description || 'N/A'}
						</pre>
					</div>

					<div className="col-md-12">
						<hr/>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Student's First Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.firstName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Student's Middle Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.middleName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Student's Last Name</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.lastName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Student's Class</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.classroomName || "N/A"}
						</h6>
					</div>

					<div className="col-md-4 mt-2 mb-2">
						<label className="form-label">Student's Stream</label>
						<h6
							style={{
								fontSize: "18px"
							}}
						>
							{studentData.streamName || "N/A"}
						</h6>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Payment Collection Form</h6>
								<hr/>

								<div className="row">

									<div className="col-md-12 mt-2 mb-2">
										<label className="form-label">Total Required</label>
										<h6
											style={{
												fontSize: "32px",

											}}
											className="font-semi-bold"
										>
											{formatMoney(paymentProfileInScope.amount)} TZS
										</h6>
									</div>

									<div className="col-md-6 mt-2 mb-2 text-success">
										<label className="form-label">Total Paid</label>
										<h6
											style={{
												fontSize: "22px",

											}}
											className="font-semi-bold"
										>
											{formatMoney(paymentProfileInScope.amountPaid)} TZS
										</h6>
									</div>

									<div className="col-md-6 mt-2 mb-2 text-danger">
										<label className="form-label">Balance</label>
										<h6
											style={{
												fontSize: "22px",

											}}
											className="font-semi-bold"
										>
											{formatMoney(paymentProfileInScope.balance)} TZS
										</h6>
									</div>

									<div className="col-md-12">
										<hr/>
									</div>

									<div className="col-md-12 mt-2 mb-2">
										<label className="form-label">Amount</label>
										<input
											className="form-control"
											value={amount}
											onChange={(e) => setAmount(e.target.value)}
										/>
									</div>

									<div className="col-md-6 mt-2 mb-2">
										<label className="form-label">Payment Date</label>
										<input
											className="form-control"
											value={paymentDate}
											onChange={(e) => setPaymentDate(e.target.value)}
											type="date"
										/>
									</div>

									<div className="col-md-6 mt-2 mb-2">
										<label className="form-label">Paid with</label>
										<select
											className="form-control"
											value={payWith}
											onChange={(e) => setPayWith(e.target.value)}
										>
											<option value=""></option>
											<option value="cash" >Cash</option>
											<option value="bank" >Bank</option>
											<option value="credit_card" >Credit Card</option>
											<option value="mobile_money" >Mobile Money</option>
										</select>
									</div>

									<div className="col-md-12 mt-2 mb-2">
										<label className="form-label">Receipt ID</label>
										<input
											className="form-control"
											value={receiptId}
											onChange={(e) => setReceiptId(e.target.value)}
										/>
									</div>

									<div className="col-md-12 mt-2 mb-2">
										<label className="form-label">Receipt File</label>
										<input
											className="form-control"
											type="file"
											id="_receiptFile"
										/>
									</div>

									<div className="col-md-12 mt-2 mb-2">
										<button
											className="btn btn-block btn-primary btn-padded btn-rounded"
											onClick={() => {
												appContext.activateDialog({
													message: "Are you  sure you want to submit this payment?",
													onConfirm: submitPayment,
												})
											}}
										>
											SUBMIT
										</button>
									</div>


								</div>
							</div>
						</div>
					</div>
					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}